import React from 'react';
import {Link} from 'gatsby';
import HeaderCart from '../HeaderCart';
import useSiteMeta from '../../query/useSiteMeta';

import styles from './styles.module.css';
import Menu from '../Menu';

const Header = () => {
  const data = useSiteMeta();
  return (
    <>
      <header className={styles.header}>
        <div className={styles.header__container}>
          <div className={styles.header__logo}>
            <Link to="/">
              <span>{data.siteName}</span>
            </Link>
          </div>
          <HeaderCart />
        </div>
      </header>
      <Menu />
    </>
  );
};

export default Header;
